import { Action } from '../interface'

interface SupplyWarningAlert {
  showSupplyWarningAlert: boolean
}

const supplyWarningAlert: SupplyWarningAlert = {
  showSupplyWarningAlert: true
}

export const supplyWarningAlertReducer = (
  state: SupplyWarningAlert = supplyWarningAlert,
  action: Action
): SupplyWarningAlert => {
  switch (action.type) {
    case 'SET_SHOW_SUPPLY_WARNING_ALERT':
      console.log('action.value for supplyAlert:', action.value)
      return {
        ...state,
        showSupplyWarningAlert: action.value
      }
    default:
      return {
        ...state,
        showSupplyWarningAlert: false
      }
  }
}
